// extracted by mini-css-extract-plugin
export default {"tax":"_49P2A"};